import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import producto from './producto/sagas'
import categoria from './categoria/sagas'
import iva from './iva/sagas'
import url from './url/sagas'
import cartel from './cartel/sagas'
import provincia from './provincia/sagas'
import fechaSenalada from './fechaSenalada/sagas'
import fechasSenaladasUrl from './fechaSenaladaUrl/sagas'
import etiqueta from './etiqueta/sagas'
import etiquetaUrl from './etiquetaUrl/sagas'
import fechaNoEntrega from './fechaNoEntrega/sagas'
import franjaHorario from './franjaHorario/sagas'
import diaEspecial from './diaEspecial/sagas'
import caso3bis from './caso3bis/sagas'
import codigoPostalConflictivo from './codigoPostalConflictivo/sagas'
import paises from './paises/sagas'
import codigosPostalesInternacionales from './codigosPostalesInternacionales/sagas'
import horarioEntregaMadrid from './horarioEntregaMadrid/sagas'
import codigosPostales from './codigoPostal/sagas'
import consultaEmails from './consultaEmail/sagas'
import articulos from './articulo/sagas'
import historialStocks from './historialStock/sagas'
import frutas from './fruta/sagas'
import proveedores from './proveedor/sagas'
import banners from './banner/sagas'
import categoriasHome from './categoriaHome/sagas'
import productosSemanaHome from './productosSemanaHome/sagas'
import traduccionesPagina from './traduccionPagina/sagas'
import urlGrupos from './urlGrupos/sagas'
import menuSitio from './menuSitio/sagas'
import fechaBloqueada from './fechaBloqueada/sagas'
import paginaOkTemplate from './paginaOkTemplate/sagas'
import mailTemplate from './mailTemplate/sagas'
import ventas from './venta/sagas'
import cache from './cache/sagas'
import descuentos from './descuentos/sagas'
import horariosEntrega from './horarioEntrega/sagas'
import bibPredSvg from './bibpredsvg/sagas'
import bibPlantilla from './bibplantilla/sagas'
import tiposSvg from './tiposSvg/sagas'
import fonts from './fonts/sagas'
import formasPago from './formaPago/sagas'
import estados from './estados/sagas'
import ladrones from './ladron/sagas'
import fechasColor from './fechaColor/sagas'
import distribuidor from './distribuidor/sagas'
import combosSvg from './combossvg/sagas'
import dhl from './dhl/sagas'
import bibPregunta from './bibpregunta/sagas'
import departamento from './departamento/sagas'
import usuario from './usuario/sagas'
import bibFamilia from './bibfamilia/sagas'
import bibFondoFamilia from './bibfondofamilia/sagas'
import etiquetaFamilia from './etiquetafamilia/sagas'
import personalizacionProducto from './personalizacionProducto/sagas'
import colorLego from './colorlego/sagas'
import stickers from './stickers/sagas'
import etiquetasComidas from './etiquetasComidas/sagas'
import productoGenerico from './productoGenerico/sagas'
import productoGenericoBoceto from './productoGenericoBoceto/sagas'
import reclamaciones from './reclamaciones/sagas'
import bibPrecios from './bibPrecios/sagas'
import productosDesayuno from './productosDesayuno/saga'
import bibAvatares from './avatares/sagas'
import lotesImpresion from './lotesimpresion/sagas'
import transportistas from './transportistas/sagas'
import codigoPostalRestriccionesMovilidad from './codigoPostalRestriccionesMovilidad/sagas'
import restriccionEntrega from './restriccionentrega/sagas'
import paisesInfo from './paisesInfo/sagas'
import productoEnCaja from './productosencaja/sagas'
import productosMasVendidos from './productosMasVendidos/sagas'
import jobs from './jobs/saga'
import estadosUsuarios from './estadosUsuarios/sagas'
import rolesApp from './roles/sagas'
import firewallIps from './firewallip/saga'
import sync from './sync/sagas'

export default function* rootSaga() {
  yield all([
    user(),
    menu(),
    settings(),
    producto(),
    categoria(),
    iva(),
    url(),
    cartel(),
    provincia(),
    fechaSenalada(),
    fechasSenaladasUrl(),
    etiqueta(),
    etiquetaUrl(),
    fechaNoEntrega(),
    franjaHorario(),
    diaEspecial(),
    caso3bis(),
    codigoPostalConflictivo(),
    paises(),
    codigosPostalesInternacionales(),
    horarioEntregaMadrid(),
    codigosPostales(),
    consultaEmails(),
    articulos(),
    historialStocks(),
    frutas(),
    proveedores(),
    banners(),
    categoriasHome(),
    productosSemanaHome(),
    traduccionesPagina(),
    urlGrupos(),
    menuSitio(),
    fechaBloqueada(),
    paginaOkTemplate(),
    mailTemplate(),
    ventas(),
    cache(),
    descuentos(),
    horariosEntrega(),
    bibPredSvg(),
    formasPago(),
    tiposSvg(),
    fonts(),
    estados(),
    ladrones(),
    fechasColor(),
    distribuidor(),
    bibPlantilla(),
    combosSvg(),
    dhl(),
    bibPregunta(),
    departamento(),
    usuario(),
    bibFamilia(),
    etiquetaFamilia(),
    bibFondoFamilia(),
    personalizacionProducto(),
    colorLego(),
    stickers(),
    etiquetasComidas(),
    productoGenerico(),
    productoGenericoBoceto(),
    reclamaciones(),
    bibPrecios(),
    productosDesayuno(),
    bibAvatares(),
    lotesImpresion(),
    transportistas(),
    codigoPostalRestriccionesMovilidad(),
    restriccionEntrega(),
    paisesInfo(),
    productoEnCaja(),
    productosMasVendidos(),
    jobs(),
    estadosUsuarios(),
    rolesApp(),
    firewallIps(),
    sync(),
  ])
}
